import React from "react";

export default function EyeSelector({
  SurgeryFormData,
  handleInputChange,
  showLabel = false,
}) {
  const options = [
    { display: "Right", value: "od" },
    { display: "Left", value: "os" },
    { display: "Both", value: "ou" },
  ];

  return (
    <div className="flex gap-2 items-center justify-center">
      {showLabel && (
        <label
          htmlFor="eye"
          className="text-sm font-medium text-gray-700 mr-2"
        >
          Select Eye:
        </label>
      )}
      {options.map((item) => (
        <button
          key={item.value}
          type="button"
          onClick={() =>
            handleInputChange({
              target: {
                id: "eye",
                value: item.value,
              },
            })
          }
          className={`
            px-4 py-1.5 rounded-full border text-sm font-medium transition-all
            ${
              SurgeryFormData.eye === item.value
                ? "bg-blue-600 text-white border-blue-600"
                : "bg-white text-blue-600 border-blue-600"
            }
          `}
        >
          {item.display}
        </button>
      ))}
    </div>
  );
}